import _nth from "ramda/src/nth";
import _head from "ramda/src/head";
import _tap from "ramda/src/tap";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _chain from "ramda/src/chain";
import _toPairs from "ramda/src/toPairs";
import _has from "ramda/src/has";
import _path from "ramda/src/path";
import _prop from "ramda/src/prop";
import _last from "ramda/src/last";
import _propOr from "ramda/src/propOr";
import _pipe from "ramda/src/pipe";
var lastCursor = _pipe(_propOr([], 'edges'), _last, _prop('cursor'));
export var connectionEndCursor = function connectionEndCursor(connection) {
  return _path(['pageInfo', 'endCursor'], connection) || lastCursor(connection);
};
export var connectionNodes = function connectionNodes(connection) {
  var edges = _prop('edges', connection);
  if (!edges) throw Error('Connection must select { edges }');
  return edges.map(function (edge, i) {
    if (!_has('node', edge)) {
      throw Error("Missing node for edge ".concat(i, ". Connection must select { edges { node } }"));
    }
    return edge.node;
  });
};
export var assertValidConnection = function assertValidConnection(connection) {
  var pageInfo = _prop('pageInfo', connection);
  if (!pageInfo) throw Error('Connection must select { pageInfo }');
  if (!_has('hasNextPage', pageInfo)) {
    throw Error('Connection must select { pageInfo { hasNextPage } }');
  }
  var endCursor = connectionEndCursor(connection);
  if (pageInfo.hasNextPage && !endCursor) {
    throw Error('Connection must select either { pageInfo { endCursor } } or { edges { cursor } }');
  }
};
export var findFirstConnection = _pipe(_toPairs, _chain(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    val = _ref2[1];
  if (_prop('pageInfo', val)) return [[key, val]];
  if (_prop('edges', val)) return [[key, val]];
  return [];
}), _tap(function (connections) {
  if (!connections.length) {
    throw Error('No relay connection found. Please set config.connection');
  }
  if (connections.length !== 1) {
    throw Error("Found multiple relay connections [".concat(connections.map(_head).join(', '), "] Please set config.connection"));
  }
}), _head, _nth(1));